import React, { useEffect, useState } from 'react'
import logger from '../../../../../../utils/logger'

export const CustomSpanComponent = ({ userData, label }) => {

    const [data, setData] = useState(null)

    useEffect(() => {

        if (userData) {
            setData(userData)
        }

    }, [userData])


    logger.info('userData CustomSpanComponent:', data)

    return (

        <>

            {data != null &&
                (
                    <div className="form-floating formFloatingStyle">
                        <p className='labelStyle'>{label}</p>
                        <span className='editable-1'>{data}</span>
                        <hr className="mp-hr-dto" />
                    </div>

                )}

        </>

    )
}
